module.exports = __webpack_public_path__ + "static/ui-header-7c845d3f5d9c226973d6c5fad3b8ce7b.png";